import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Breadcrumbs,
  BottomNavigation,
  BottomNavigationAction,
  Card,
  Container,
  Link,
  Typography
} from '@material-ui/core';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import ScoreIcon from '@material-ui/icons/Score';
import StorageIcon from '@material-ui/icons/Storage';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import Page from 'src/components/Page';
import AssignedJobs from './AssignedJobs';
import Productivity from './Productivity';
import OneTimeService from './OneTimeService';
import AppointmentCompliance from './AppointmentCompliance';
import Nps from './Nps';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }
}));

function Dashboard({ className, handleRefresh, loading, setTask }) {
  const classes = useStyles();
  const { t } = useTranslation('Dashboard');
  const SessionUser = getUser();
  var TitleApp = "Sirius CRM";
  if (SessionUser.Role === 2) {
    TitleApp = "Sirius Partner"
  }
  
  const [TopBarValue, setTopBarValue] = React.useState(0);
  return (
    <Page className={classes.root} title={TitleApp}>
      <Container maxWidth="xl">
        <Card className={clsx(classes.root, className)}>
          <BottomNavigation
            value={TopBarValue}
            className={classes.stickToBottom}
            onChange={(event, newValue) => {
              setTopBarValue(newValue);
            }}
            showLabels
          >
            <BottomNavigationAction
              label={t('lblAssignedJobs')}
              icon={<BusinessCenterIcon />}
            />
            <BottomNavigationAction
              label={t('lblProductivity')}
              icon={<TrendingUpIcon />}
            />
            <BottomNavigationAction
              label={t('lblOneTimeService')}
              icon={<StorageIcon />}
            />
            <BottomNavigationAction
              label={t('lblAppointmentCompliance')}
              icon={<EventAvailableIcon />}
            />
            <BottomNavigationAction label={t('lblNps')} icon={<ScoreIcon />} />
          </BottomNavigation>
        </Card>
        <Card>
          <div className={classes.content}>
            {TopBarValue === 0 && (
              <>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link color="inherit">Sirius</Link>
                  <Typography color="textPrimary">
                    {t('lblAssignedJobs')}
                  </Typography>
                </Breadcrumbs>
                <AssignedJobs />
              </>
            )}
            {TopBarValue === 1 && (
              <>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link color="inherit">Sirius</Link>
                  <Typography color="textPrimary">
                    {t('lblProductivity')}
                  </Typography>
                </Breadcrumbs>
                <Productivity />
              </>
            )}
            {TopBarValue === 2 && (
              <>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link color="inherit">Sirius</Link>
                  <Typography color="textPrimary">
                    {t('lblOneTimeService')}
                  </Typography>
                </Breadcrumbs>
                <OneTimeService />
              </>
            )}
            {TopBarValue === 3 && (
              <>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link color="inherit">Sirius</Link>
                  <Typography color="textPrimary">
                    {t('lblAppointmentCompliance')}
                  </Typography>
                </Breadcrumbs>
                <AppointmentCompliance />
              </>
            )}
            {TopBarValue === 4 && (
              <>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link color="inherit">Sirius</Link>
                  <Typography color="textPrimary">{t('lblNps')}</Typography>
                </Breadcrumbs>
                <Nps />
              </>
            )}
          </div>
        </Card>
      </Container>
    </Page>
  );
}

export default Dashboard;
